module.exports = __webpack_public_path__ + "static/img/basemusic.c14f3fff.png";